
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16zM17.651 9.96h-5.355c-.272-.001-.543-.002-.814.001a.803.803 0 00-.806.82l.001 9.69c0 .08.012.163.034.24.106.366.41.582.813.582h9.707a.806.806 0 00.769-.805v-9.722a.876.876 0 00-.01-.127.828.828 0 00-.833-.682c-1.168.006-2.337.005-3.506.004zm-.938 4.78l.001.196c.265-.416.603-.69 1.049-.806a2.349 2.349 0 011.59.132c.515.231.756.678.88 1.202.09.384.11.775.109 1.168-.003.958-.003 1.917 0 2.876 0 .101-.028.134-.13.134-.48-.005-.961-.005-1.441 0-.11 0-.137-.04-.137-.143.003-.891.006-1.783-.001-2.674a3.136 3.136 0 00-.07-.66c-.09-.402-.339-.59-.748-.596a1.449 1.449 0 00-.366.035c-.392.098-.559.395-.624.761a3.174 3.174 0 00-.044.537c-.004.867-.003 1.734 0 2.6.002.108-.028.14-.135.14-.48-.005-.961-.005-1.441 0-.11 0-.137-.036-.137-.141.003-1.723.003-3.446 0-5.169 0-.104.025-.14.136-.139.462.007.925.006 1.388 0 .1 0 .127.034.124.129-.004.135-.003.271-.003.418zm-4.379 2.747v-.57-.591c0-.666 0-1.332-.002-1.998 0-.1.023-.134.128-.133.487.006.975.005 1.462 0 .09 0 .123.023.123.12-.003 1.736-.002 3.472 0 5.208 0 .086-.025.12-.114.12a116.35 116.35 0 00-1.483 0c-.097 0-.116-.04-.116-.127.003-.677.002-1.353.002-2.03zm1.839-4.995a.978.978 0 01-.985.977.975.975 0 01-.981-.98.983.983 0 111.966.003z","fill":"currentColor"}})])
          )
        }
      }
    